module.exports = __webpack_public_path__ + "media/evolve/assets/icons/planned/speaker-mute-b7db89684c954c8200ae4a0da55e432f.svg";